export const assessments = {
  root: {
    name: 'Assessments',
    path: '/assessments',
    title: 'assessments.survey',
    meta: {
      shouldAssessmentEnabled: true,
      requiresAuth: true,
      hideSideBar: true,
      showOnlyLogo: true,
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Assessments`,
    },
  },
  assessmentsPage: {
    name: 'Assessments Options',
    path: '/assessments/:assessmentId',
    title: 'assessments.assessmentsPage',
    meta: {
      shouldAssessmentEnabled: true,
      requiresAuth: true,
      hideSideBar: true,
    },
  },
};
